import React, { useState } from "react";
import { PayPalButtons } from "@paypal/react-paypal-js";
import { activateSubscription } from "../services/api";

interface PayPalWrapperProps {
    plan: "medio" | "full";
    onSuccess: (plan: string) => void;
}

const MEDIO_PLAN_ID = process.env.REACT_APP_PAYPAL_BASIC_PLAN_ID || "P-09M45447CM028984JNJQBFOY";
const FULL_PLAN_ID = process.env.REACT_APP_PAYPAL_FULL_PLAN_ID || "P-9M778989RD2384201NJQBG5Y";

const PayPalWrapper: React.FC<PayPalWrapperProps> = ({ plan, onSuccess }) => {
    const [isActivating, setIsActivating] = useState(false);

    return (
        <div style={{ position: 'relative' }}>
            {isActivating && (
                <div className="text-center p-3 mb-2 bg-light border rounded shadow-sm animate__animated animate__pulse animate__infinite">
                    <div className="spinner-border spinner-border-sm text-primary me-2" role="status"></div>
                    <span className="fw-bold">Procesando activación...</span>
                </div>
            )}
            <div style={{ opacity: isActivating ? 0.5 : 1, pointerEvents: isActivating ? 'none' : 'auto' }}>
                <PayPalButtons
                    style={{ layout: "vertical", shape: "rect" }}
                    createSubscription={(data, actions) => {
                        const planId = plan === "medio" ? MEDIO_PLAN_ID : FULL_PLAN_ID;
                        if (planId.includes("REPLACE")) {
                            alert("El plan Full aún no está configurado.");
                            throw new Error("Plan Full no configurado");
                        }
                        return actions.subscription.create({
                            plan_id: planId
                        });
                    }}
                    onApprove={async (data) => {
                        if (data.subscriptionID) {
                            try {
                                setIsActivating(true);
                                const result = await activateSubscription(data.subscriptionID, plan);
                                if (result && result.status === "SUCCESS") {
                                    // Notify parent of success - parent will handle UI and navigation
                                    onSuccess(result.plan);
                                } else {
                                    alert("Hubo un problema al activar tu suscripción. Por favor contacta a soporte.");
                                    setIsActivating(false);
                                }
                            } catch (error) {
                                console.error("Subscription activation error:", error);
                                alert("Error al procesar la suscripción. Revisa tu conexión.");
                                setIsActivating(false);
                            }
                        }
                    }}
                    onError={(err) => {
                        console.error("CRITICAL: PayPal SDK Error:", err);
                        alert("Error de PayPal: El plan podría no estar activo o los IDs no coinciden. Revisa la consola.");
                    }}
                />
            </div>
        </div>
    );
};

export default PayPalWrapper;